import {useEffect, useState} from "react";

export const PAGE_MODE_BREAKPOINT = 768;

export function useIsNarrow(breakpoint = PAGE_MODE_BREAKPOINT) {
    const [isNarrow, setIsNarrow] = useState(() => window.innerWidth < breakpoint);

    useEffect(() => {
        const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const handler = (e) => setIsNarrow(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [breakpoint]);

    return isNarrow;
}
